<template>
    <div
        :class="{
            'mb-4': margin === true,
        }"
    >
        <h6 v-if="label" class="subtitle bold">{{ label }}</h6>
        <BaseInput
            ref="baseInput"
            v-bind="$attrs"
            :value="value"
            :padding="padding"
            :outline="outline"
            :icon="icon"
            :class="[enumKey]"
            v-on="listeners"
        />
        <h6 v-if="helperText" class="subtitle mt-2" :class="{ 'error-color': error === true }">
            {{ helperText }}
        </h6>
    </div>
</template>

<script>
import StateEnum, { IconMap } from '~/utils/StateEnum';
export default {
    name: 'TextField',
    props: {
        label: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
        padding: Boolean,
        margin: Boolean,
        helperText: {
            type: String,
            default: '',
        },
        error: {
            type: Boolean,
            default: false,
        },
        outline: {
            type: Boolean,
            default: true,
        },
        stateEnum: {
            type: Number,
            default: undefined,
        },
    },
    methods: {
        onChange(value) {
            this.$emit('input', value);
        },
        focus() {
            this.$refs.baseInput.focus();
        },
    },
    computed: {
        enumKey() {
            return Object.keys(StateEnum)[this.stateEnum] || '';
        },
        icon() {
            return IconMap[this.stateEnum] || '';
        },
        listeners() {
            return {
                ...this.$listeners,
                input: this.onChange,
            };
        },
    },
    mounted() {
        this.inputValue = this.$props.value;
    },
};
</script>
